export default "__VITE_ASSET__6RrlqQ0A__$_?format=webp__"